'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBellAndMessage, iconBellAndMessageTag } from '@ni/nimble-components/dist/esm/icons/bell-and-message';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBellAndMessage };
export { iconBellAndMessageTag };
export const NimbleIconBellAndMessage = wrap(IconBellAndMessage);